module.exports = __webpack_public_path__ + "img/ether.0f35b657.svg";